export const BILLS_EVENTS = {
  VIEW_BILLS_PAGE: 'view_bills_page',
  BILLS_TRANSFER_INITIATED: 'bills_transfer_initiated',
  BILLS_TRANSFER_CONFIRMED: 'bills_transfer_confirmed',
  BILLS_TRANSFER_OTP_VERIFIED: 'Bills Transfer OTP Verified',
  BILLS_TRANSFER_COMPLETED: 'Bills Transfer Completed',
  BILLS_TRANSFER_FAILED: 'Bills Transfer Failed',
  SELECT_ALL_SERVICES: 'select_all_services',
  SELECTED_SAVED_BILLS: 'selected_saved_bills',
  VIEW_SAVED_BILLS: 'view_saved_bills',
  SELECTED_BILLS_HISTORY: 'selected_bills_history',
  VIEW_BILLS_HISTORY: 'view_bills_history',
  BILLS_SERVICE_CATEGORY_SELECTED: 'bills_service_category_selected',
  BILLS_SERVICE_CATEGORY_PAGE_VIEWED: 'bills_service_category_page_viewed',
  BILLS_ADD_FUNDS_SELECTED: 'bills_add_funds_selected',
  BILLS_ADD_FUNDS_PAGE_VIEWED: 'bills_add_funds_page_viewed',
  BILLS_TOP_UP_CONFIRMED_STATUS: 'bills_top_up_confirmed_status',
  BILLS_MOBILE_WALLET_TOP_UP_SELECTED: 'bills_mobile_wallet_top_up_selected',
  BILLS_YOUR_BALANCE_TOP_UP_SELECTED: 'bills_your_balance_top_up_selected',
  BILLS_TOP_UP_CONFIRMED: 'bills_top_up_confirmed',
  BILLS_WALLET_NEXT_STEPS_POP_UP_VIEWED: 'bills_wallet_next_steps_pop_up_viewed',
  BILLS_WALLET_NEXT_STEPS_POP_UP_CONTINUE_BUTTON_SELECTED: 'bills_wallet_next_steps_pop_up_continue_button_selected',
  BILLS_CONTINUE_SELECTED: 'bills_continue_selected',
  BILLS_CHECKOUT_PAGE_VIEWED: 'bills_checkout_page_viewed',
  BILLS_PAY_SELECTED: 'bills_pay_selected',
  BILLS_PARTIAL_PAYMENT_SELECTED: 'bills_partial_payment_selected',
  BILLS_PARTIAL_PAYMENT_PAGE_VIEWED: 'bills_partial_payment_page_viewed',
  BILLS_PARTIAL_PAYMENT_CONFIRMED: 'bills_partial_payment_confirmed',
  BILLS_SCREEN_EXITED: 'bills_screen_exited',
  BILLS_BACK_SELECTED: 'bills_back_selected',
  BILLS_SAVE_BILL_SELECTED: 'bills_save_bill_selected',
  BILLS_CONNECT_AD_ACCOUNT_SELECTED: 'bills_connect_ad_account_selected',
  BILLS_PAY_ADS_NOW_SELECTED: 'bills_pay_ads_now_selected',
  BILLS_CONVERTED_PAY_HOME_PAGE_VIEWED: 'bills_converted_pay_home_page_viewed',
  BILLS_TOP_UP_AD_ACCOUNT_SELECTED: 'bills_top_up_ad_account_selected',
  BILLS_ADS_TOP_UP_PAGE_VIEWED: 'bills_ads_top_up_page_viewed',
  BILLS_AD_ACCOUNT_TOP_UP_CONFIRMED: 'bills_ad_account_top_up_confirmed',
  BILLS_CONNECT_AD_ACCOUNT_FROM_SETTINGS_SELECTED: 'bills_connect_ad_account_from_settings_selected',
  BILLS_DISCONNECT_AD_ACCOUNT_SELECTED: 'bills_disconnect_ad_account_selected',
  BILLS_HISTORY_BILL_SELECTED: 'bills_history_bill_selected',
  BILLS_BILL_DETAILS_PAGE_VIEWED: 'bills_bill_details_page_viewed',
  BILLS_SAVED_BILL_SELECTED: 'bills_saved_bill_selected',
};

export const BILLS_EVENTS_PARAMS = {
  IS_DISTRIBUTOR: 'is_distributor',
  BILLS_BALANCE: 'bills_balance',
  STATUS: 'request_status',
  ERROR: 'error_description',
  BILLS_PENDING_BALANCE: 'pending_balance',
  HAS_SAVED_MERCHANTS: 'has_saved_merchants',
  IS_SAVE_BENEFICIARY: 'is_saved_merchant',
  RECEIPT_MID: 'recipient_mid',
  BILL_CATEGORY: 'bill_category',
  BILL_PROVIDER: 'bill_provider',
  BILL_SERVICE: 'bill_service',
  TOTAL_AMOUNT: 'total_amount',
  TRANSACTION_ID: 'transaction_id',
  SAVE_BILL: 'save_bill',
  REMAINING_BILLS_BALANCE: 'remaining_bills_balance',
  METHOD: 'method',
  TYPE: 'type',
  AMOUNT: 'amount',
  PARTIAL_AMOUNT: 'partial_amount',
  SCREEN_NAME: 'screen_name',
  FLOW_STEP: 'flow_step',
  EXIT_TYPE: 'exit_type',
  BILL_AMOUNT: 'bill_amount',
  AD_PLATFORM: 'ad_platform',
  AD_ACCOUNT_ID: 'ad_account_id',
  IS_FIRST_TIME: 'is_first_time',
  CONNECTED_ACCOUNTS_COUNT: 'connected_accounts_count',
  BILL_STATUS: 'bill_status',
};